import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Search from '@ifeng/ui_pc_search';
import { formatUrl } from '@ifeng/public_method';
import Ad from '@ifeng/ui_pc_ad';
import styles from './index.css';
import { classnames } from '../../../utils/classnames';
import { rel as relText } from '../../../utils/rel';

class Logo extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    // 显示logo还是title
    displayLogoOrTitleView(item) {
        if ('logo' in item && item.logo && item.logo !== '') {
            return <img className={styles.logo_image} src={item.logo} alt={item.title} />;
        } else {
            return <b className={styles.logo_text}>{item.title}</b>;
        }
    }
    render() {
        const { content } = this.props;
        const { channel, noAd, guanmingAd } = content;

        return (
            <div className={classnames(styles.logo_box, 'clearfix')}>
                <div className={styles.logoBox2}>
                    <a href={`//${channel[0].domain}`} target="_blank" rel={relText}>
                        <img className={styles.logo_finace} src={formatUrl(channel[0].logo)} alt={channel[0].title} />
                    </a>
                    {channel.length === 1 && channel[0].slogen && channel[0].slogen !== '' ? (
                        <img className={styles.slogen} src={formatUrl(channel[0].slogen)} />
                    ) : null}
                </div>
                {channel[1] ? this.displayLogoOrTitleView(channel[1]) : null}
                {channel[2] ? (
                    <span className={styles.logo_second_text}>
                        <span className={styles.logo_gt}>&gt;</span>
                        {channel[2].title}
                    </span>
                ) : null}
                {/* 广告 */}
                {!noAd && guanmingAd ? <Ad styleName={styles.ad} content={guanmingAd} /> : null}
                <Search content={content.search} />
            </div>
        );
    }
}

export { Logo };
export default Logo;
